import React, { useEffect, useState, useCallback } from "react";
import Card from "components/Layout/Card";
import Button from "components/form/Button";
import TextArea from "components/form/TextArea";
import { icons } from "utils/constants";
import moment from "moment";
import axios from "axios";
import { useDispatch } from "react-redux";
import { addComments, throwSuccess } from "store/slices";
import { formattedDateTime, objectToFormData } from "utils/helpers";
import { useParams } from "react-router-dom";
import LeadStatus from "../LeadStatus";
import usePermission from "hooks/usePermission";


const Remarks = ({ paperData, onLeadChange, onSuccess }) => {
    const { viewAccess, createAccess, updateAccess, deleteAccess } = usePermission('Event Management');

    const [remarks, setRemarks] = useState();
    const [commentVal, setCommentVal] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(true);
    const [showAddRemark, setShowAddRemark] = useState(false);
    const dispatch = useDispatch()
    const { paperId } = useParams()
    const { lead } = paperData


    useEffect(() => {
        setRemarks(paperData?.all_remarks || [])
        setIsFetching(false)
    }, [paperData])

    const handleSubmit = async () => {
        if (!commentVal.trim()) return;
        setIsLoading(true);
        const payload = { remarks: commentVal.trim(), abstract_paper_id: paperId };
        const response = await dispatch(addComments(objectToFormData(payload)));
        if (response?.status === 200) {
            const newRemark = response?.data;
            setRemarks((prev) => [newRemark, ...prev]);
            onSuccess?.({ ...paperData, all_remarks: [newRemark, ...remarks] });
            setCommentVal("");
            setShowAddRemark(false);
            dispatch(throwSuccess(response?.message));
        }
        setIsLoading(false);

    };

    const handleClear = () => {
        setCommentVal("");
        setShowAddRemark(false);
    };

    if (isFetching) {
        return (
            <Card className="cps-25 cpt-16 cpe-25 cpb-16">
                <div className="text-center p-4">Loading remarks...</div>
            </Card>
        );
    }

    return (
        <Card className="cps-25 cpt-16 cpe-25 cpb-16">
            <div className="d-flex justify-content-between align-items-center cmb-14">
                <div className="text-16-500 color-1717 ">
                    Remarks of this submitted paper
                </div>
                {updateAccess === "1" &&
                    <LeadStatus abstract_id={paperId} lead={lead} onSuccess={(newLead) => onLeadChange(newLead)} isTitle />}
            </div>
            <div className="border-bottom cmb-18 color-d1d1"></div>

            {remarks.length > 0 ? (
                <>
                    <div className="cmb-20 overflow-auto"
                        style={{ maxHeight: "250px" }}>
                        {remarks.map((elm, index) => (
                            <div
                                key={index}
                                className="d-flex flex-column cmb-20 p-3 border br-10"
                                style={{ backgroundColor: "#F5F5FF" }}
                            >
                                <div className="text-14-400-18 color-6866 cmb-10">
                                    {formattedDateTime(elm?.created_at)}
                                </div>
                                <div className="text-14-300-24">{elm?.remarks}</div>
                            </div>
                        ))}
                    </div>

                    <div className="text-14-500 color-black-olive cmb-10">Add Remarks*</div>
                    <TextArea
                        value={commentVal}
                        rows={3}
                        placeholder="Enter your remark..."
                        onChange={(e) => setCommentVal(e.target.value)}
                    />
                    <div className="d-flex align-items-center gap-2 cmt-16">
                        {createAccess === "1" &&
                            <Button
                                text="Submit"
                                btnStyle="primary-dark"
                                className="h-35 text-14-500 w-auto px-4"
                                onClick={handleSubmit}
                                disabled={!commentVal.trim() || isLoading}
                                btnLoading={isLoading}
                            />
                        }
                        <Button
                            text="Clear"
                            btnStyle="light-outline"
                            className="h-35 text-14-500 w-auto px-3"
                            onClick={handleClear}
                            disabled={isLoading}

                        />
                    </div>
                </>
            ) : (
                <>
                    {!showAddRemark ? (
                        <div className="d-flex flex-column justify-content-center align-items-center cpb-125">
                            <div className="text-center cmt-56">
                                <img
                                    src={icons.circleInfo}
                                    alt="No Data"
                                    style={{ height: "40px", width: "40px" }}
                                />

                                <h3 className="cmt-22 text-24-500-30 color-dark-gray">
                                    Remarks Not Found
                                </h3>
                                {createAccess === "1" &&
                                    <div className="cmt-22 d-flex justify-content-center">
                                        <Button
                                            text="+ Add Remarks"
                                            btnStyle="primary-outline"
                                            className="h-35 text-14-500 w-auto px-3"
                                            onClick={() => setShowAddRemark(true)}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="text-14-500 color-black-olive cmb-10">
                                Add Remarks*
                            </div>
                            <TextArea
                                value={commentVal}
                                rows={3}
                                placeholder="Enter your remark..."
                                onChange={(e) => setCommentVal(e.target.value)}
                            />
                            <div className="d-flex align-items-center justify-content-start gap-2 cmt-16">
                                {createAccess === "1" &&
                                    <Button
                                        text="Submit"
                                        btnStyle="primary-dark"
                                        className="h-35 text-14-500 w-auto px-4"
                                        onClick={handleSubmit}
                                        disabled={!commentVal.trim() || isLoading}
                                        btnLoading={isLoading}
                                    />
                                }
                                <Button
                                    text="Clear"
                                    btnStyle="light-outline"
                                    className="h-35 text-14-500 w-auto px-3"
                                    onClick={handleClear}
                                    disabled={isLoading}
                                />
                            </div>
                        </>
                    )}
                </>
            )}
        </Card>
    );
};

export default Remarks;
